import styled from 'styled-components';
import { Flex, Box } from 'reflexbox/styled-components';

import Section from '@/components/section';
import Button from '@/components/button';
import TitleBase from '@/components/title';
import ParagraphBase from '@/components/paragraph';

const Title = styled(TitleBase)`
  color: ${props => props.theme.colors.typography.inverted};
  font-size: 3em;
  margin-top: 0;
`;

const Paragraph = styled(ParagraphBase)`
  color: ${props => props.theme.colors.typography.inverted};
`;

const Location = () => {
  const style = {
    backgroundImage: 'url(/images/background-location.jpg)',
    backgroundSize: 'cover',
    marginBottom: '2em'
  };

  return (
    <Section backgroundColor="#4A2F82" style={style}>
      <Flex flexWrap="wrap">
        <Box width={[1, 1/2]} />
        <Box width={[1, 1/2]}>
          <Title>Based in Canada.<br />Built with ❤️ around the world.</Title>
          <Paragraph>Bidali is a remote-first team that embraces decentralization. It’s in our fabric. Born out of necessity, we’ve come together to transform the way people transact around the world and without borders.</Paragraph>
          <Paragraph>Interested in helping us build a more open global economy?</Paragraph>
          <Button to="/careers/" size="large">Join the Team</Button>
        </Box>
      </Flex>
    </Section>
  );
};

export default Location;
